/* Jacka: camper details in the cart. Saves fields as cart attributes and blocks checkout until the required ones are filled. */
(function () {
  if (customElements.get('jacka-cart-fitment')) return;

  class JackaCartFitment extends HTMLElement {
    constructor() {
      super();
      this._timer = null;
      this._onInput = this._onInput.bind(this);
      this._onCheckoutClick = this._onCheckoutClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('input', this._onInput);
      this.addEventListener('change', this._onInput);
      document.addEventListener('click', this._onCheckoutClick, true);
    }

    disconnectedCallback() {
      this.removeEventListener('input', this._onInput);
      this.removeEventListener('change', this._onInput);
      document.removeEventListener('click', this._onCheckoutClick, true);
      clearTimeout(this._timer);
    }

    get fields() {
      return Array.from(this.querySelectorAll('[name^="attributes["]'));
    }

    attributes() {
      var out = {};
      this.fields.forEach(function (f) {
        out[f.name.replace(/^attributes\[(.*)\]$/, '$1')] = f.value.trim();
      });
      return out;
    }

    _onInput(evt) {
      if (evt.target && evt.target.classList) evt.target.classList.remove('is-invalid');
      var err = this.querySelector('.jacka-fitment__error');
      if (err && !this.missing().length) err.hidden = true;
      clearTimeout(this._timer);
      var self = this;
      this._timer = setTimeout(function () { self.save(); }, 400);
    }

    save() {
      var url = (window.routes && window.routes.cart_update_url) ? window.routes.cart_update_url : '/cart/update';
      if (!/\.js$/.test(url)) url += '.js';
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: this.attributes() })
      }).catch(function () {});
    }

    missing() {
      return this.fields.filter(function (f) { return f.hasAttribute('required') && !f.value.trim(); });
    }

    _onCheckoutClick(evt) {
      if (this.dataset.required !== 'true') return;
      var btn = evt.target && evt.target.closest ? evt.target.closest('button[name="checkout"], [type="submit"]') : null;
      if (!btn) return;
      var formId = btn.getAttribute('form') || (btn.form && btn.form.id);
      if (formId !== this.dataset.formId) return;
      var missing = this.missing();
      var err = this.querySelector('.jacka-fitment__error');
      if (!missing.length) { if (err) err.hidden = true; return; }
      evt.preventDefault();
      evt.stopPropagation();
      missing.forEach(function (f) { f.classList.add('is-invalid'); });
      if (err) {
        err.textContent = this.dataset.error || 'Please tell us about your camper before checking out.';
        err.hidden = false;
      }
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      missing[0].focus({ preventScroll: true });
    }
  }

  customElements.define('jacka-cart-fitment', JackaCartFitment);
})();
